import {
  GET_QA_TRANSCRIPTION_FILE,
  GET_QA_TRANSCRIPTION_FILE_SUCCESS,
  GET_QA_TRANSCRIPTION_FILE_FAILED,
  QA_DESICISION_TRANSCRIPTION_FILE,
  QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS,
  QA_DESICISION_TRANSCRIPTION_FILE_FAILED,
  FETCH_REJECT_REASON_LIST,
  FETCH_REJECT_REASON_LIST_SUCCESS,
  FETCH_REJECT_REASON_LIST_FAILED,
  FETCH_AUDITED_LIST_BY_USER,
  FETCH_AUDITED_LIST_BY_USER_SUCCESS,
  FETCH_AUDITED_LIST_BY_USER_FAILED,
  GET_SUPER_QA_TRANSCRIPTION_FILE,
  GET_SUPER_QA_TRANSCRIPTION_FILE_SUCCESS,
  GET_SUPER_QA_TRANSCRIPTION_FILE_FAILED,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED,
  API_URL,
  GET_QA_AUDIO,
  GET_QA_AUDIO_SUCCESS,
  GET_QA_AUDIO_FAILED,
  GET_SQA_AUDIO,
  GET_SQA_AUDIO_SUCCESS,
  GET_SQA_AUDIO_FAILED,
  QA_DESICISION_AUDIO_FILE,
  QA_DESICISION_AUDIO_FILE_SUCCESS,
  QA_DESICISION_AUDIO_FILE_FAILED,
  SQA_DESICISION_AUDIO_FILE,
  SQA_DESICISION_AUDIO_FILE_SUCCESS,
  SQA_DESICISION_AUDIO_FILE_FAILED,
} from "../constants/constants";
import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";

function* fetchQATranscriptionAudio(action) {
  const { userType, userId } = action.payload;
  const toPost = {
    userId,
  };

  // const endPoint = userType === '2' ? 'get-transcipt-quality-check' : (userType === '3' || userType === '5') ? 'get-audio-quality-check' : ''
  const endPoint = "get-transcipt-quality-check";
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: GET_QA_TRANSCRIPTION_FILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: GET_QA_TRANSCRIPTION_FILE_FAILED, data: error });
  }
}

function* fetchSQATranscriptionAudio(action) {
  const { userId, start_date, end_date, searchValue, selectedOption } =
    action.payload;
  const toPost = {
    UserId: userId,
    Fromdate: start_date,
    Todate: end_date,
    AuditUserId: searchValue,
    Flag: selectedOption,
  };

  // const endPoint = userType === '2' ? 'get-transcipt-quality-check' : (userType === '3' || userType === '5') ? 'get-audio-quality-check' : ''
  const endPoint = "get-transcript-super-audit";
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: GET_SUPER_QA_TRANSCRIPTION_FILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: GET_SUPER_QA_TRANSCRIPTION_FILE_FAILED, data: error });
  }
}
function* fetchQAAudio(action) {
  const { userType, userId } = action.payload;
  const toPost = {
    userId,
  };

  // const endPoint = userType === '2' ? 'get-transcipt-quality-check' : (userType === '3' || userType === '5') ? 'get-audio-quality-check' : ''
  const endPoint = "get-audio-quality-check";
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: GET_QA_AUDIO_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: GET_QA_AUDIO_FAILED, data: error });
  }
}

function* fetchSQAAudio(action) {
  const { userId, start_date, end_date, searchValue, selectedOption } =
    action.payload;
  const toPost = {
    UserId: userId,
    Fromdate: start_date,
    Todate: end_date,
    AuditUserId: searchValue,
    Flag: selectedOption,
  };

  // const endPoint = userType === '2' ? 'get-transcipt-quality-check' : (userType === '3' || userType === '5') ? 'get-audio-quality-check' : ''
  const endPoint = "get-audio-super-audit";
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: GET_SQA_AUDIO_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: GET_SQA_AUDIO_FAILED, data: error });
  }
}

function* QATranscriptionDecision(action) {
  const { userId, transcriptId, quality, transcript, error_id, userType } =
    action.payload;
  const endPoint = "upadte-transcipt-quality-check";
  let toPost = { userId, transcriptId, quality, error_id, transcript };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: QA_DESICISION_TRANSCRIPTION_FILE_FAILED, data: error });
  }
}

function* SQATranscriptionDecision(action) {
  const { userId, transcriptId, quality, transcript, error_id, userType } =
    action.payload;
  const endPoint = "update-super-transcript-audit";
  let toPost = {
    userId,
    id: transcriptId,
    quality_status: quality,
    transcript,
  };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({
      type: SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS,
      data: result,
    });
  } catch (error) {
    yield put({
      type: SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED,
      data: error,
    });
  }
}

function* QAAudioDecision(action) {
  const { userId, transcriptId, quality, transcript, error_id, userType } =
    action.payload;
  const endPoint = "update-audio-quality-check";
  let toPost = { userId, id: transcriptId, error_id, quality };

  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: QA_DESICISION_AUDIO_FILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: QA_DESICISION_AUDIO_FILE_FAILED, data: error });
  }
}

function* SQAAudioDecision(action) {
  const { userId, transcriptId, quality, transcript, error_id, userType } =
    action.payload;
  const endPoint = "update-super-audio-audit";
  let toPost = { userId, id: transcriptId, error_id, quality };

  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: SQA_DESICISION_AUDIO_FILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: SQA_DESICISION_AUDIO_FILE_FAILED, data: error });
  }
}

function* fetchRejectReajonList() {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/get-error-types`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_REJECT_REASON_LIST_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_REJECT_REASON_LIST_FAILED, data: error });
  }
}

function* getAuditedListByUser(action) {
  const {
    object: { user_id, startdate, enddate },
  } = action;
  const toPost = {
    user_id,
    startdate,
    enddate,
  };
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/get-audio-superaudit`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_AUDITED_LIST_BY_USER_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_AUDITED_LIST_BY_USER_FAILED, data: error });
  }
}

function* superQAAudioDecision(action) {
  const { userId, transcriptId, quality, transcript, error_id, userType } =
    action.payload;
  const endPoint =
    userType === "6"
      ? "update-super-transcript-audit"
      : userType === "5"
      ? "update-super-audio-audit"
      : "";
  let toPost =
    userType === "6"
      ? { userid: userId, id: transcriptId, quality, error_id, transcript }
      : userType === "5"
      ? { userid: userId, id: transcriptId, error_id, quality }
      : {};

  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/${endPoint}`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({
      type: SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS,
      data: result,
    });
  } catch (error) {
    yield put({
      type: SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED,
      data: error,
    });
  }
}

function* QAManagement() {
  yield takeLatest(GET_QA_TRANSCRIPTION_FILE, fetchQATranscriptionAudio);
  yield takeLatest(GET_SUPER_QA_TRANSCRIPTION_FILE, fetchSQATranscriptionAudio);
  yield takeLatest(QA_DESICISION_TRANSCRIPTION_FILE, QATranscriptionDecision);
  yield takeLatest(
    SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
    SQATranscriptionDecision
  );
  yield takeLatest(QA_DESICISION_AUDIO_FILE, QAAudioDecision);
  yield takeLatest(SQA_DESICISION_AUDIO_FILE, SQAAudioDecision);
  yield takeLatest(FETCH_REJECT_REASON_LIST, fetchRejectReajonList);
  yield takeLatest(FETCH_AUDITED_LIST_BY_USER, getAuditedListByUser);
  // yield takeLatest(
  //   SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
  //   superQAAudioDecision
  // );
  yield takeLatest(GET_QA_AUDIO, fetchQAAudio);
  yield takeLatest(GET_SQA_AUDIO, fetchSQAAudio);
}

export default QAManagement;
